var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagingIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.705 4.5h-6v-1h6v1zM6.705 6.5h-3v-1h3v1z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.281.5h10.988a.785.785 0 01.785.774v7.439a.785.785 0 01-.785.773H6.116l-2.237 2.049a.5.5 0 01-.837-.37V9.487H1.274A.785.785 0 01.5 8.713V1.274A.785.785 0 011.274.5h.007zm.22 1v6.986h2.04a.5.5 0 01.5.5v1.044l1.543-1.413a.5.5 0 01.337-.13h6.133V1.5H1.5z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.038h-6.107v-1h6.322a.785.785 0 01.785.774v7.439a.785.785 0 01-.785.774h-1.762l-.02 1.685a.5.5 0 01-.838.363l-2.232-2.049H9.706a.78.78 0 01-.781-.78v-2.589h1v2.37h6.133a.5.5 0 01.338.131l1.55 1.423.013-1.06a.5.5 0 01.5-.495H20.5V6.038z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.576 8h3.883v1h-3.883V8zM11.8 10h6.66v1H11.8v-1z",
    fill: "#1C1C1C"
  })));
}
export default SvgMessagingIcon;